import { render, staticRenderFns } from "./PerformanceAlertBlocker.vue?vue&type=template&id=7bdcd2f7&scoped=true"
import script from "./PerformanceAlertBlocker.vue?vue&type=script&lang=js"
export * from "./PerformanceAlertBlocker.vue?vue&type=script&lang=js"
import style0 from "./PerformanceAlertBlocker.vue?vue&type=style&index=0&id=7bdcd2f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdcd2f7",
  null
  
)

export default component.exports